import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SettingService } from './setting.service';

@Injectable()
export class DashboardService {
  constructor(private settings: SettingService,
              private http: HttpClient) {
  }
  api = 'school-program-http/api/v1';

  getStudentActivityMetrics(params: any) {
    const requestUrl = this.settings.getConfig('api.url') + '/' + this.api + '/dashboard-student/activity-data/' + params.academic_year + '/' + params.student_id + '/' + params.school_program_activity_id + '/' + params.period_id;
    // const requestUrl = 'http://localhost:3075/school-program-http/api/v1/dashboard-student/activity-data/' + params.academic_year + '/' + params.student_id + '/' + params.school_program_activity_id + '/' + params.period_id;

    return this.http.get<any>(requestUrl, this.settings.httpOptionWithSession());
  }

  getStudentSchedules(params: any) {
    const requestUrl = this.settings.getConfig('api.url') + '/' + this.api + '/dashboard-student/schedule/' + params.academic_year + '/' + params.student_id ;
    // const requestUrl = 'http://localhost:3075/school-program-http/api/v1/dashboard-student/schedule/' + params.academic_year + '/' + params.student_id;

    return this.http.get<any>(requestUrl, this.settings.httpOptionWithSession());
  }

  getStudentActivityList(params: any) {
    const requestUrl = this.settings.getConfig('api.url') + '/' + this.api + '/dashboard-student/activity-list';
    // const requestUrl = 'http://localhost:3075/school-program-http/api/v1/dashboard-student/activity-list';

    return this.http.post<any>(requestUrl, params, this.settings.httpOptionWithSession());
  }


}
